@let warnRegionsValue = warningService.warnRegions();
@let selectedRegionValue = warningService.selectedRegion();
@if (warnRegionsValue.summer.length + warnRegionsValue.winter.length > 1) {
  <div>
    <!-- more than one warn region to select -->
    <div class="panel">
      <span class="panel__text">{{
        'PRODUCT.WARNING.SEASON.' + selectedRegionValue.season | translate
      }}</span>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'PRODUCT.WARNING.select' | translate }}</mat-label>
        <mat-select
          [formControl]="regionControl"
          placeholder="{{ 'PRODUCT.WARNING.select' | translate }}">
          @for (season of warningService.seasons(); track $index) {
            @if (warnRegionsValue[season].length > 0) {
              <mat-optgroup
                [label]="'PRODUCT.WARNING.SEASON.' + season | translate">
                @for (region of warnRegionsValue[season]; track $index) {
                  <mat-option
                    [value]="season + region.id"
                    (onSelectionChange)="onRegionChange(season, $event)">
                    {{ region.name }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
} @else {
  <!-- one warn region -->
  @if (selectedRegionValue) {
    <div class="single-selected-region">
      {{ 'PRODUCT.WARNING.SEASON.' + selectedRegionValue.season | translate }}
      {{ selectedRegionValue.name }}
    </div>
  }
}

<mat-card appearance="outlined" class="course-warning-card">
  @let allWarningDataValue = warningService.allWarningData();
  @if (
    allWarningDataValue[selectedRegionValue.season].hasOwnProperty(
      selectedRegionValue.id
    ) &&
    allWarningDataValue[selectedRegionValue.season][selectedRegionValue.id]
      .length > 0
  ) {
    <mat-list>
      @for (
        warning of allWarningDataValue[selectedRegionValue.season][
          selectedRegionValue.id
        ];
        track $index
      ) {
        <mat-list-item>
          <!--
            <fa-stack matListIcon [ngClass]="'list-icon warn-color-' + warning['color']">
              <fa-icon [icon]="['fas', 'circle']" stackItemSize="2x"></fa-icon>
              <fa-icon [icon]="['fas', warning['symbol']]" [inverse]="true" stackItemSize="1x"
                       transform="right-4 up-1"></fa-icon>
            </fa-stack>
            -->
          <div matListItemIcon>
            <fa-icon
              [icon]="['far', warning['symbol']]"
              [ngClass]="'warn-color-' + warning['color']"
              size="2x"
              transform="down-8 right-2">
            </fa-icon>
          </div>
          <div class="overview-warning__text-container">
            <p matListItemLine class="mat-body-strong overview-warning__title">
              {{ 'PRODUCT.WARNING.TYPE.' + warning['type'] | translate }}
            </p>
            <div matListItemLine class="overview-warning__date">
              <fa-icon [icon]="['far', 'clock']"></fa-icon>
              {{
                warning['dtg']
                  | datex
                    : 'dd DD.MM.YY HH:mm'
                    : undefined
                    : languageService.langSignal()
              }}
              {{ 'DATETIME.CLOCK' | translate }}
            </div>
            @if (warning['color'] !== 'warning') {
              <div matListItemLine>
                <app-no-warning
                  [type]="warning['type']"
                  [message]="warning.message">
                </app-no-warning>
              </div>
            } @else {
              @for (warnline of warning['message'].split('\,'); track $index) {
                <span matListItemLine> {{ warnline }} <br /> </span>
              }
            }
          </div>
        </mat-list-item>
        <mat-divider class="overview-warning__list-divider"></mat-divider>
      }
    </mat-list>
  }
</mat-card>
